export const appBaseURL = "/storefinder/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width,initial-scale=1,maximum-scale=1"},{"charset":"utf-8"},{"name":"description","content":"StoreFinder"},{"name":"theme-color","content":"#2BB5FD"}],"link":[],"style":[],"script":[{"innerHTML":"var n=document.currentScript.nonce;if(n){var c=document.createElement.bind(document);document.createElement=function(t,o){var e=c(t,o);if(t==='script'&&!e.src)e.setAttribute('nonce',n);return e}}","type":"text/javascript"},{"id":"cookieyes","type":"text/javascript","src":"https://cdn-cookieyes.com/client_data/7cbaa872bb5720e8f0a685e63d594962/script.js"}],"noscript":[],"title":"Store Finder - TruRating","viewport":"width=device-width,initial-scale=1,maximum-scale=1"}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true